import React from 'react';
import { motion } from 'framer-motion';

export default function SystemSection() {
  const lines = [
    "Every year, millions of parents report bullying.",
    "Most never hear back.",
    "No follow-up.",
    "No update.",
    "No one held to anything.",
    "That is not a family problem.",
    "That is a system problem.",
    "And systems can change."
  ];

  return (
    <section className="w-full py-24 md:py-40 border-t border-gray-100">
      <div className="max-w-4xl mx-auto text-center md:text-left">
        <div className="flex flex-col gap-4 md:gap-6">
          {lines.map((line, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`text-2xl md:text-4xl font-bold tracking-tight ${
                i >= 5 ? 'text-deep-blue' : 'text-navy'
              }`}
            >
              {line}
            </motion.p>
          ))}
        </div>
      </div>
    </section>
  );
}